import { observer } from "mobx-react-lite";

import { Card } from "@bps/fluent-ui";

import { CommunicationHistoryList } from "./components/CommunicationHistoryList.tsx";

const CommunicationHistoryScreen: React.FC = observer(() => {
  return (
    <Card
      headingLevel="section-heading"
      heading="Communication history"
      iconName="BpDocEdit"
      styles={{
        header: { padding: "8px 0 12px 8px" },
        subComponentStyles: {
          tile: {
            content: {
              padding: 0,
              position: "relative",
              display: "flex"
            },
            header: { border: "none" },
            root: {
              height: "100%",
              padding: 16,
              maxWidth: 1500,
              margin: "0 auto"
            }
          }
        }
      }}
    >
      <CommunicationHistoryList />
    </Card>
  );
});

// ⚠ It should be exported as default since it is used for React.lazy
// eslint-disable-next-line import/no-default-export
export default CommunicationHistoryScreen;
